import { useState } from "react";
import { createClient } from "@supabase/supabase-js";
import { useNavigate } from "react-router-dom";
import zxcvbn from "zxcvbn";
import Footer from "./Footer";
const supabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_KEY);

export default function Signup() {
  const navigate = useNavigate();
  const [step] = useState("signup");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [strength, setStrength] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleDiscordSignup() {
    setLoading(true);
    setError("");

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "discord",
        options: {
          redirectTo: "https://offmetafantasy.com/choose-region",
        },
      });
      if (error) throw error;
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSignup(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error } = await supabase.auth.signUp({
      email,
      password,
    });

    setLoading(false);

    if (error) {
      setError(error.message);
      return;
    }

    navigate("/choose-region");
  }

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setPassword(pwd);

    const result = zxcvbn(pwd);
    setStrength(result.score); // 0–4
  };

  const strengthLabel = ["Very Weak", "Weak", "Fair", "Good", "Strong"];
  const strengthColor = ["#ff4d4f", "#ff7a45", "#ffa940", "#bae637", "#52c41a"];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100vh",
        backgroundImage: 'url("/background-grid.svg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div className="center-container" style={{ gap: "20px" }}>
        <img src="/logo.svg" alt="logo" />

        <div className="signup-preview-box">
          <div className="center-box">
            {error && <p style={{ color: "#f14646" }}>{error}</p>}
            {loading && <p style={{ color: "white" }}>Loading..</p>}

            {step === "signup" && (
              <div>
                <h2 style={{ color: " white", margin: "0" }}>Create Account</h2>
                <h4 style={{ color: "white", letterSpacing: "-0.4px", fontWeight: "400", opacity: "0.3", marginBottom: "40px" }}>
                  Level up your viewing experience in 3 easy steps
                </h4>
                <form onSubmit={handleSignup}>
                  <input type="email" placeholder="Email" value={email} required onChange={(e) => setEmail(e.target.value)} />
                  <input type="password" placeholder="Password" value={password} required onChange={handlePasswordChange} />

                  {password && (
                    <div style={{ marginTop: "8px" }}>
                      <div
                        style={{
                          height: "8px",
                          background: "#e0e0e0",
                          borderRadius: "4px",
                          overflow: "hidden",
                        }}>
                        <div
                          style={{
                            width: `${(strength + 1) * 20}%`,
                            background: strengthColor[strength],
                            height: "100%",
                            transition: "width 0.3s ease",
                          }}
                        />
                      </div>
                      <small style={{ color: strengthColor[strength] }}>{strengthLabel[strength]}</small>
                      {password.length < 6 && (
                        <small style={{ color: "red", display: "block", marginTop: "4px" }}>Password must be at least 6 characters</small>
                      )}
                    </div>
                  )}

                  <button disabled={password.length < 6} type="submit" style={{ marginBottom: "20px" }}>
                    Sign Up
                  </button>
                </form>
                <button
                  onClick={handleDiscordSignup}
                  disabled={loading}
                  className="discord-button"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    width: "100%",
                    maxWidth: "392px",
                    justifyContent: "center",
                    padding: "14px 16px",
                    backgroundColor: "#5865F2",
                    color: "#fff",
                    border: "none",
                    fontWeight: "600",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}>
                  <img src="/discord.svg" alt="Discord" className="discord-icon" style={{ width: 20, height: 20 }} />
                  {loading ? "Redirecting..." : "Signup with Discord"}
                </button>
                <a href="/login" className="return-link">
                  Already have an account? Login
                </a>
              </div>
            )}

            {step === "verify" && (
              <div>
                <p style={{ color: "white" }}>
                  Please check your email <strong>{email}</strong> for a verification link.
                </p>
                <p style={{ color: "white" }}>Make sure to check the spam folder aswell.</p>
                <p style={{ color: "white" }}>After verifying, you can close this page.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
